import type { Dispatch, FC, SetStateAction } from 'react';
import { KaimonoWebRoutes } from 'src/config/routes';
import {
  LARGE_CATEGORY_PAGE_PATH,
  MIDDLE_CATEGORY_PAGE_PATH,
  SMALL_CATEGORY_PAGE_PATH,
  TINY_CATEGORY_PAGE_PATH
} from 'src/constants/pagePath';
import type {
  LargeCategorySchema,
  MiddleCategorySchema,
  SmallCategorySchema,
  TinyCategorySchema
} from 'src/models/category/schema';
import { mixpanel } from 'src/utils/mixpanel';
import { CategoryLink } from './CategoryLinkComponents';
import { PrevLink } from './PrevLink';

type Props = {
  categories: LargeCategorySchema[] | MiddleCategorySchema[] | SmallCategorySchema[] | TinyCategorySchema[];
  route: string;
  pathname: string;
  isCategoryListOpen: boolean;
  setIsCategoryListOpen: Dispatch<SetStateAction<boolean>>;
  parentCategorySlug: () => string;
  getSmallOrTinyCategoryLink: (slug: string) => string;
  setActiveCategorySlug: Dispatch<SetStateAction<string>>;
  categoryType: 'largeCategory' | 'middleCategory' | 'smallCategory' | 'tinyCategory';
  activeCategorySlug: string;
};

export const Presenter: FC<Props> = ({
  categories,
  pathname,
  route,
  parentCategorySlug,
  getSmallOrTinyCategoryLink,
  setActiveCategorySlug,
  categoryType,
  activeCategorySlug
}) => (
  <div className="max-m-[820px] px-4 pb-7 semiLg:px-6 semiLg:pb-8 flex flex-wrap gap-2.5 items-center">
    <PrevLink route={route} parentSlug={parentCategorySlug()} />
    {categories.map((category) => {
      const slug = category['slug'];
      const pathToRouteMap: Record<string, string> = {
        [LARGE_CATEGORY_PAGE_PATH]: KaimonoWebRoutes.middleCategories.show(slug),
        [MIDDLE_CATEGORY_PAGE_PATH]: KaimonoWebRoutes.smallCategories.show(slug),
        [SMALL_CATEGORY_PAGE_PATH]: getSmallOrTinyCategoryLink(slug),
        [TINY_CATEGORY_PAGE_PATH]: KaimonoWebRoutes.tinyCategories.show(slug)
      };
      const href = pathToRouteMap[pathname] ?? KaimonoWebRoutes.tinyCategories.show(slug);

      const isActive =
        (pathname === SMALL_CATEGORY_PAGE_PATH || pathname === TINY_CATEGORY_PAGE_PATH) &&
        activeCategorySlug === category.slug;

      return (
        <CategoryLink
          key={slug}
          href={href}
          name={category.name}
          onClick={() => {
            mixpanel.onCategoryClickedInCategoryPage(categoryType, slug);
            if (pathname === TINY_CATEGORY_PAGE_PATH) setActiveCategorySlug(category.slug);
          }}
          isActive={isActive}
        />
      );
    })}
  </div>
);
